module.exports = __webpack_public_path__ + "static/media/2DOFSpringMassSystemProof.ea0567f0.mp4";